import { takeLatest } from 'redux-saga/effects';
import { sagaApiGenWithPromise } from 'utils/sagaApiGeneratorHelpers';
import { flowLanguagesActions } from '../actions/flowLanguages';
import { getAllLanguages } from '../api/flowLanguages';
const { flowGetLanguages, flowGetLanguagesSucceeded, flowGetLanguagesFailed } = flowLanguagesActions;
// Saga
export const flowLanguages = [
    takeLatest(flowGetLanguages.toString(), sagaApiGenWithPromise(getAllLanguages, flowGetLanguagesSucceeded, flowGetLanguagesFailed)),
];
